import { Space, Button, Tooltip, Popconfirm, Tag } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Tag as AntTag } from 'antd';
import CustomButton from '../../components/global/Button/CustomButton';

const ActiveStatus = {
  Active: {
    color: "rgba(6, 103, 16, 1)",
    borderColor: "rgba(149, 222, 157, 1)",
    label: "Active",
  },
  Inactive: {
    color: "rgba(145, 14, 17, 1)",
    background: "rgba(249, 243, 243, 1)",
    borderColor: "rgba(243, 163, 175, 1)",
    label: "Inactive",
  },
}

export const AdminDomainColumns = (handleEdit, handleDelete, isInactive,isAdminSupport) => [
  {
    title: 'Domain Name',
    dataIndex: 'domain',
    key: 'domain',
    width: "30%",
  },
  {
    title: 'Status',
    dataIndex: 'isActive',
    key: 'status',
    width: "30%",
    render: (isActive) => {
     const label = isActive ? "Active" : "Inactive";
     const styles = ActiveStatus[label];
      return (
      <Tag
              className="w-[80px] text-center !px-4 !py-[10px] !rounded-[10px] !border !font-medium"
              style={{
                  color: styles.color,
                  borderColor: styles.borderColor,
                  backgroundColor: styles.background,
              }}
              >
              {styles.label}
              </Tag>
      );
    },
  },
  {
    title: 'Actions',
    key: 'actions',
    width: "13%",
    render: (_, record) => (
      <Space size="middle">
        <Tooltip title="Edit Domain">
          <CustomButton
          disabled={isAdminSupport}
            variant="outlined"
            onClick={() => handleEdit(record)}
          >
            Edit
          </CustomButton>
        </Tooltip>

        {isInactive && (
          <Tooltip title="Delete Domain">
            <CustomButton
            disabled={isAdminSupport}
            variant="outlined"
            onClick={() => handleDelete(record)}
          >
            Delete
          </CustomButton>
          </Tooltip>
        )}
      </Space>
    ),
  },
];